import { render, staticRenderFns } from "./OutstandingDetails.vue?vue&type=template&id=1f35dfa5&"
import script from "./OutstandingDetails.vue?vue&type=script&lang=js&"
export * from "./OutstandingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports